export const NOTIFICATION_BAR_COLOR = {
  info: 'bg-primary',
  success: 'bg-primary',
  error: 'bg-red-500',
  warning: 'bg-amber-400',
}
